/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";

import * as API from "../../../../api/billing";
import Button from "../../../reusable/button";
import ErrorMessage from "../../../reusable/errorMessage";
import {
  StyledInput,
  StyledLabel,
  StyledModalBody,
  StyledModalContents,
  StyledButtonContainer,
} from "../lib/styles";
import { handleErrorsArray } from "../../../../utils";

const StyledError = styled.div`
  text-align: right;
  margin-top: 16px;
`;

const StyledButton = styled(Button)`
  margin-top: 0;
  float: right;
`;

const StyledContainer = styled(StyledButtonContainer)`
  justify-content: flex-end;
`;

type AdjustRewardBalanceModalBodyProps = {
  closeModal: () => void;
  fetchData: (loadFirstPage: boolean) => void;
};

const AdjustRewardBalanceModalBody = ({
  closeModal,
  fetchData,
}: AdjustRewardBalanceModalBodyProps): React.ReactElement => {
  const [amount, setAmount] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleAdjustBalanceClick = async (): Promise<void> => {
    try {
      const data = {
        company_payment: {
          // NOTE: amount_in_cents is actually amount in usd and the credits_controller converts it to cents
          amount_in_cents: parseFloat(amount).toFixed(2),
          description,
        },
      };
      await API.postRewardBalanceAdjustment(data);
      await fetchData(true);
      closeModal();
    } catch (error) {
      const errors = handleErrorsArray(error);
      setErrorMessage(errors);
    }
  };

  return (
    <StyledModalBody data-testid="adjust-reward-balance-modal-body">
      <StyledModalContents>
        <StyledLabel htmlFor="amount">
          {i18n.translate(
            "admin_pages.activity.adjust_reward_balance_modal.amount_in_dollars"
          )}
        </StyledLabel>
        <StyledInput
          id="amount"
          name="amount"
          onChange={(event): void => {
            return setAmount(event.target.value);
          }}
          type="number"
          value={amount}
        />
        <StyledLabel htmlFor="description">
          {i18n.translate(
            "admin_pages.activity.adjust_reward_balance_modal.description"
          )}
        </StyledLabel>
        <StyledInput
          id="description"
          name="description"
          onChange={(event): void => {
            return setDescription(event.target.value);
          }}
          placeholder={i18n.translate(
            "admin_pages.activity.adjust_reward_balance_modal.description_hint"
          )}
          type="text"
          value={description}
        />
      </StyledModalContents>
      <StyledContainer>
        <StyledButton
          disabled={!amount || !description}
          onClick={handleAdjustBalanceClick}
          size="small"
          testId="adjust-balance-button"
          variant="primary"
        >
          {i18n.translate(
            "admin_pages.activity.adjust_reward_balance_modal.create_adjustment"
          )}
        </StyledButton>
        {errorMessage && (
          <StyledError>
            <ErrorMessage
              errorMessage={errorMessage}
              testId="adjust-reward-balance-error"
            />
          </StyledError>
        )}
      </StyledContainer>
    </StyledModalBody>
  );
};

export default AdjustRewardBalanceModalBody;
